import React from 'react';
import { array, bool } from 'prop-types';
import ProductDetail from './../product-detail/ProductDetail';
import './ProductDetails.css';

function ProductDetails({ details, notStylish }) {
  const classNotStylish = notStylish && 'not-stylish';
  return (
    <aside className={`box-package__details ${classNotStylish}`}>
      {details.map((detail, index) => <ProductDetail key={detail.text} detail={detail} hideDivider={details.length === (index + 1)} notStylish={notStylish} />)}
    </aside>
  );
}

ProductDetails.propTypes = {
  details: array.isRequired,
  notStylish: bool,
};

ProductDetails.defaultProps = {
  notStylish: false,
};

export default ProductDetails;
